module.exports = __webpack_public_path__ + "img/首页联系我们.36f6ea21.png";